import i18nFactory from '@yandex-int/i18n';
import { Action } from 'redux';
import { Epic } from 'redux-observable';
import { Observable } from 'rxjs';

import { ShowGroupEditErrorAction } from '../../actions/groupsEdit';
import {
    openRetargetingConditionEditor,
    SAVE_RETARGETING_CONDITION_AS_NEW_SUCCESSED,
    SAVE_RETARGETING_CONDITION_SUCCESSED,
    SaveRetargetingConditionAsNewSuccessed,
    SaveRetargetingConditionSuccessed
} from '../../actions/retargetingConditionEditor';
import {
    addRetargetingListItem,
    CancelDeleteRetargetingListItem,
    cancelDeleteRetargetingListItem,
    DeleteRetargetingListItem,
    deleteRetargetingListItem,
    EDIT_RETARGETING_LIST_ITEM,
    EditRetargetingListItem,
    REQUEST_DELETE_RETARGETING_LIST_ITEM,
    RequestDeleteRetargetingListItem,
    updateRetargetingListItem
} from '../../actions/retargetingEditor';
import { mapApiResponseDeleteRetargetingConditions } from '../../mappers/retargeting/retargeting';
import { ApiMethodExecutingError } from '../../service/Errors';
import { showNoticeMessage } from '../../service/GridHelpers/GridHelpers';
import { EpicDeps } from '../../service/StoreFactory';
import { NoticeType } from '../../typings/grid';
import { State } from '../../typings/state';

import * as keyset from './retargetingEditor.i18n';

const i18n = i18nFactory(keyset);

export const deleteRetargetingListItemEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) => {
    return action$.ofType(REQUEST_DELETE_RETARGETING_LIST_ITEM).mergeMap((action: RequestDeleteRetargetingListItem) => {
        const state = store$.value;
        const { commonData, retargetingEditor } = state;
        const { login } = commonData;

        const currentRetargetingEditor = retargetingEditor[action.id];
        const { conditions } = currentRetargetingEditor;
        const currentCondition = conditions[action.index];

        const showDeleteRetargetingListItemError = () => {
            showNoticeMessage(NoticeType.error, i18n('error-delete-retargeting-list-item'), {
                timeout: 'none'
            });

            return Observable.of(cancelDeleteRetargetingListItem(action.id, action.index));
        };

        return Observable.fromPromise(
            deps.retargetingMutationExecutor.deleteRetargetingConditions(login, [currentCondition.id])
        )
            .mergeMap(
                (
                    result
                ): Observable<
                    DeleteRetargetingListItem | CancelDeleteRetargetingListItem | ShowGroupEditErrorAction
                > => {
                    const response = mapApiResponseDeleteRetargetingConditions(result);

                    if (response.success) {
                        showNoticeMessage(NoticeType.success, i18n('deleted-success'));

                        return Observable.of(deleteRetargetingListItem(action.id, action.index));
                    } else {
                        return showDeleteRetargetingListItemError();
                    }
                }
            )
            .catch(
                (error: ApiMethodExecutingError): Observable<CancelDeleteRetargetingListItem> => {
                    return showDeleteRetargetingListItemError();
                }
            );
    });
};

export const editRetargetingListItemEpic: Epic<Action, Action, State, EpicDeps> = (action$, store, deps) => {
    return action$.ofType(EDIT_RETARGETING_LIST_ITEM).map((action: EditRetargetingListItem) => {
        const { isSelected, isDeleting, ...conditionData } = store.value.retargetingEditor[action.id].conditions[
            action.index
        ];

        return openRetargetingConditionEditor(action.id, conditionData);
    });
};

export const updateRetargetingConditionEpic: Epic<Action, Action, State, EpicDeps> = (action$, store, deps) => {
    return action$.ofType(SAVE_RETARGETING_CONDITION_SUCCESSED).map((action: SaveRetargetingConditionSuccessed) => {
        return updateRetargetingListItem(action.conditionData);
    });
};

export const addRetargetingConditionEpic: Epic<Action, Action, State, EpicDeps> = (action$, store, deps) => {
    return action$
        .ofType(SAVE_RETARGETING_CONDITION_AS_NEW_SUCCESSED)
        .map((action: SaveRetargetingConditionAsNewSuccessed) => {
            return addRetargetingListItem(action.groupId, action.conditionData);
        });
};
